import React, { useContext } from "react";
import Application from "../../../components/application"
import MyLabel from "../../../components/myLabel";
import MyPanel from "../../../components/myPanel";
import MyButton from "../../../components/myButton";
import MyLoading from "../../../components/myLoading";
import { useNavigate } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { usePDF } from 'react-to-pdf';

import {Tooltip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import SchoolIcon from '@mui/icons-material/School';
import useColaboradoresState from "../../../hooks/useColaboradoresState";
import Styles from "./styles";
import MyCardboard from "../../../components/myCardboard";
import MyEstrelas from "../../../components/myEstrelas";
import CsvDownloader from 'react-csv-downloader';
import { AuthContext } from "../../../contexts/auth";
import TELAS from "../../../constants/telas";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";

// permissão para telas

const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.COLABORADORES,
    acoes: [TELA_ACOES.Consultar,TELA_ACOES.Imprimir]
}

const Line = ({title, value}) => {

    return (
        <Box sx={{display:'flex', flexDirection:'row'}}>
            <MyLabel sx={{marginRight:'5px', fontWeight:600}} component='p' text = {`${title}:`}/>
            <MyLabel component='p' text = {value}/>
        </Box>
    )
}

const DetalhesCursosColaborador = ()=>{

    const { id } = useParams()
    const states = useColaboradoresState()
    const [imprimindo, setImprimindo] = useState(false)
    const navigate = useNavigate()

    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    
    
    let detalhesCurso = states.detalhesCursoColaborador.value

    const { toPDF, targetRef } = usePDF({filename:  `cursos_${detalhesCurso?.nome}.pdf`});

    let styles = Styles()

    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)){
            if (id && id !== ''){
               states.detalhesCursoColaborador.set(id)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])    

    useEffect(()=>{
        let imprimir = async ()=>{
                await toPDF()
                setImprimindo(false)
           }

        if (imprimindo){
            imprimir()
        }
    }, [imprimindo]) 


    const handlerImprimir = async ()=>{
        setImprimindo(true)
    }

    let columns = [{id: 'permitido',displayName: 'Permitido'}, 
                   {id: 'curso',displayName: 'Curso'}, 
                   {id: 'video',displayName: 'Video'}, 
                   {id: 'status',displayName: 'Status'}, 
                   {id: 'data_inicio',displayName: 'Data Início'}, 
                   {id: 'data_termino',displayName: 'Data Término'}, 
                   {id: 'nota',displayName: 'Avaliação'}];

    const asyncFnComputeDate = () => {
        // do whatever you need async
        return Promise.resolve(detalhesCurso?.videos.map(item=>{return {permitido: item.permitido ? 'Com permissão' : 'Sem permissão' ,
                                                                        curso:item.curso,
                                                                        video:item.video,
                                                                        status:item.status,
                                                                        data_inicio:item.data_inicio,
                                                                        data_termino:item.data_termino,
                                                                        nota:item.nota,
                                                                        }})
        );
      };

    return (
            
            <Application>
                <MyPanel  >
                    <MyLoading render={states.submit.value || imprimindo}/>  
                    <Stack spacing={2} ref={targetRef} sx={{padding:'0 10px'}}>
                        <Box sx={{display:'flex', justifyContent:'space-between'}}>
                            <MyLabel sx={styles.title} component='h1' text={'Detalhes de Cursos Colaborador'}/>
                                {
                                    imprimindo ? <></> :
                                    <Box>
                                        <Box sx={{display:'flex', justifyContent:'end'}}>

                                            <CsvDownloader filename= {`cursos_${detalhesCurso?.nome}`}
                                                extension=".csv"
                                                separator=";"
                                                wrapColumnChar=""
                                                columns={columns}
                                                datas={asyncFnComputeDate}
                                            >
                                                <MyButton disabled={!permissaoTelas(permissaoUsuario,TELA_ACOES.Imprimir,PAGINA)} color='primary'variant='contained' text='Planilha' sx={{marginRight:'10px'}}/>
                                            </CsvDownloader>
                                            
                                            <MyButton disabled={!permissaoTelas(permissaoUsuario,TELA_ACOES.Imprimir,PAGINA)} color='primary' onClick={handlerImprimir} variant='contained' text='Imprimir' sx={{marginRight:'10px'}}/>
                                            <MyButton color='warning' onClick={()=>navigate('/gestor/colaboradores')} variant='contained' text='Voltar'/>
                                        </Box>
                                    </Box>
                                }

                        </Box>
                        <Box>
                            <Line title={'Nome'} value={detalhesCurso?.nome} />
                            <Line title={'Função'} value={detalhesCurso?.funcao} />
                            <Line title={'Posto'} value={detalhesCurso?.posto} />
                            <Line title={'Coordenador'} value={detalhesCurso?.coordenador} />
                            {
                                detalhesCurso?.lider? 
                                <Line title={'Lider'} value={'Chefe de Turma'} />
                                : null

                            }
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'start'}}>
                            <Box sx={{marginRight:'20px'}}>
                                <MyCardboard 
                                    titulo = 'Cursos' 
                                    color = 'rgb(102, 187, 106)'
                                    subtitulo = 'Concluidos'
                                    subtitulocor = 'rgb(123, 128, 154)'
                                    valor = {detalhesCurso?.cursos_terminados}
                                    Icone = {SchoolIcon}
                                />
                            </Box>
                            <MyCardboard 
                                titulo = 'Videos' 
                                color = 'rgb(73, 163, 241)'
                                subtitulo = 'Concluidos'
                                subtitulocor = 'rgb(123, 128, 154)'
                                valor = {detalhesCurso?.videos_terminados}
                                Icone = {OndemandVideoIcon}
                            />
                        </Box>

                        <Box sx={{minHeight:'200px'}}>
                            <TableContainer component={Paper} >
                                <Table size="small" aria-label="simple table">
                                    <TableHead >
                                            <TableRow >
                                                <TableCell sx={styles.tableHead}></TableCell>
                                                <TableCell sx={styles.tableHead}>Curso</TableCell>
                                                <TableCell sx={styles.tableHead}>Video</TableCell>
                                                <TableCell sx={styles.tableHead}>Status</TableCell>
                                                <TableCell sx={styles.tableHead}>Data Início</TableCell>
                                                <TableCell sx={styles.tableHead}>Data Término</TableCell>
                                                <TableCell sx={styles.tableHead}>Avaliação</TableCell>
                                            </TableRow>
                                    </TableHead>
                                    <TableBody>
                                            {
                                                detalhesCurso?.videos.map((item, key)=>{
                                                    return (
                                                        <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell component="th" scope="row" >
                                                                {
                                                                    item.permitido ? 
                                                                        <Tooltip title="Com permissão" placement="bottom" arrow> <CheckCircleOutlineIcon/></Tooltip> 
                                                                    : 
                                                                        <Tooltip title="Sem permissão" placement="bottom" arrow> <RadioButtonUncheckedIcon/></Tooltip>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >{item.curso}</TableCell>
                                                            <TableCell component="th" scope="row" >{item.video}</TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                {
                                                                    (item.status==='ASSISTIDO') ?
                                                                        <Tooltip title={item.status} placement="bottom" arrow> <OndemandVideoIcon/></Tooltip>
                                                                        : 
                                                                        <Tooltip title={item.status} placement="bottom" arrow> <PersonalVideoIcon/></Tooltip>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >{item.data_inicio}</TableCell>
                                                            <TableCell component="th" scope="row" >{item.data_termino}</TableCell>
                                                            <TableCell component="th" scope="row" sx={{width:'155px'}}>
                                                                    <MyEstrelas titulo={item.nota} nota={item.nota} />
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    
                    </Stack>
                </MyPanel>
            
            </Application>
        
    )
}

export default DetalhesCursosColaborador